export function exportChartConfigToCsv(
  chartConfig,
  fileName = 'chart-data.csv',
  delimiter = ';',
  customHeader = null // se informado, usa esse cabeçalho
) {
  const labels = chartConfig.data.labels
  const datasets = chartConfig.data.datasets

  if (!labels || !datasets || !labels.length) {
    console.warn('ChartConfig sem dados suficientes.')
    return
  }

  // Cabeçalho → usa o customizado ou gera automaticamente
  const header = customHeader
    ? customHeader.join(delimiter)
    : ['Label', ...datasets.map(ds => ds.label)].join(delimiter)

  // Linhas → combina cada label com valores de cada dataset
  const linhas = labels.map((lbl, i) => {
    const valores = datasets.map(ds => {
      const val = ds.data[i]
      // Se for número, converte para formato BR (vírgula decimal)
      if (typeof val === 'number') {
        return val.toLocaleString('pt-BR')
      }
      return val
    })
    return [lbl, ...valores].join(delimiter)
  })

  // Monta CSV com BOM para UTF-8
  const csvContent = '\uFEFF' + [header, ...linhas].join('\n')

  // Cria blob e dispara download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}



// WEBPACK FOOTER //
// ./src/helpers/exportCsvChart.js